import { render, staticRenderFns } from "./RiskAssessmentRegular.vue?vue&type=template&id=621a2d7c&scoped=true&"
import script from "./RiskAssessmentRegular.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a2d7c",
  null
  
)

export default component.exports